import { render, staticRenderFns } from "./toStoresTransfers.vue?vue&type=template&id=994a2bb4"
import script from "./toStoresTransfers.vue?vue&type=script&lang=js"
export * from "./toStoresTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports